<template>
  <section class="single-box">
    <!-- <div class="grid__main"> -->
      <div class="single-box__image" v-if="!hideImage">
        <Gallery
          :thumbnail="product.thumbnail"
          :displayType="'thumbnail'"
          :canOpen="false"
        />
      </div>
      <div class="single-box__name" v-if="!hideName">
        <router-link class="product-name" :to="product.permalink">
          <Badges :is_on_sale="product.is_on_sale"
                  :is_new="product.is_new"
                  :is_out_of_stock="product.stock_status != 'instock'"
                  :discount_percentage="product.discount_percentage || 0" />
          <h6>{{ product.name | emptyDash }}</h6>
          <span>{{ translations.readMore }}</span>
        </router-link>
      </div>
    <!-- </div> -->
<!--  -->
    <!-- <div class="grid__sub"> -->
      <VariationSubRow
        v-for="variation in sortedVariations"
        :key="`variation_${variation.id}`"
        :variation="variation"
        :showOtherInfo="showOtherInfo"
        :displayedAttributeTaxonomies="displayedAttributeTaxonomies"
        :hideSKU="hideSKU"
        :name="product.name"
       />
    <!-- </div> -->
  </section>
</template>

<style lang="scss" scoped>
.single-box {
  display: grid;
  grid-template-rows: auto [last-line];
  grid-template-columns: 6rem 20rem 1fr;
  border-bottom: 0.1rem solid lightgray;
  padding: 2rem 0;
  gap: 0 2rem;

  &__image,
  &__name {
    grid-row: 1 / last-line;
    grid-row-start: span 9000;
  }
}
</style>

<script>
import Badges from '@/layouts/general-ui/Badges.vue';
import Gallery from '@/layouts/general-ui/Gallery.vue';
import VariationSubRow from './VariationSubRow.vue';

export default {
  name: 'VariationRow',
  components: {
    Badges,
    Gallery,
    VariationSubRow,
  },
  props: {
    product: Object,
    showOtherInfo: Boolean,
    displayedAttributeTaxonomies: Array,
    hideImage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideSKU: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      translations: {
        readMore: ws_vue_store.translations.read_more,
      },
    };
  },
  filters: {
    emptyDash(value) {
      if (!value) return '-';
      return value;
    },
  },
  computed: {
    productPermalink() {
      return this.product.permalink.substring(
        this.product.permalink.indexOf(ws_vue_store.base_url) +
          ws_vue_store.base_url.length -
          1
      );
    },
    sortedVariations() {
      return this.product.variations;
    }
  }, // computed
};
</script>
